const INFO = {
	main: {
		title: "Shane Coelho Portfolio",
		name: "Shane Coelho",
		email: "coelhoshane1@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/ShaneCoelho",
		linkedin: "https://www.linkedin.com/in/shane-coelho/",
		instagram: "https://instagram.com/shane.coelho",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full-stack web and mobile app developer, and Versatile Visionary Developer.",
		description:
			"I am a software developer with expertise in React Native and ReactJs. I have experience in building scalable, secure and reliable web and mobile applications using various frameworks and technologies such as ReactJs, NodeJs and React Native. I enjoy working on complex projects. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Shane Coelho. I live in India, where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. I am currently pursuing Bachelors in Computer Engineering at St. Francis Institute of Technology. I have completed my Diploma in Computer Engineering from Bhausaheb Vartak Polytechnique. I am actively looking for internships and job roles where I can showcase my talent. My last internship was at CMOTS Internet Technologies where I worked as a FullStack developer.",
	},

	articles: {
		title: "Discover My Work Story: Where I've Been and What I've Done",
		description:
			"Explore the pages of my professional story, where each chapter unfolds a unique experience and showcases the projects that have shaped my journey. From the beginning to the present, this is a simple yet profound glimpse into my career path and the work that defines my passion and commitment.",
	},

	projects: [
		{
			title: "CrewConnect",
			description:
				"CrewConnect is an internship project for the efficient crew management and connectivity solutions for the maritime industry. This project is a mobile application developed using React Native, NodeJs and MongoDB. The project is deployed on Render",
			logo: "https://cdn.iconscout.com/icon/free/png-512/free-react-1-282599.png?f=webp&w=256",
			linkText: "View Project",
			link: "https://github.com/ShaneCoelho/CrewConnect_Frontend",
		},

		{
			title: "WorkSaga",
			description:
				"This app developed for freelancers is a platform that allows them to create a professional profile and offer their services to potential clients. Freelancers can showcase their skills, experience, and portfolio to attract clients.",
			logo: "https://cdn0.iconfinder.com/data/icons/long-shadow-web-icons/512/nodejs-512.png",
			linkText: "View Project",
			link: "https://github.com/ShaneCoelho/WorkSagaAPI",
		},

		{
			title: "HackX Website",
			description:
				"We made this website to share all about our college hackathon. This website is based on Openhiemer theme and is developed using ReactJS.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/ShaneCoelho/HackXWebsite",
		},

		{
			title: "Mosaic Website",
			description:
				"We made this website to share all about our college feast Mosaic. This website is based on Lost in Space theme and is developed using ReactJS.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/ShaneCoelho/Mosaic_Website",
		},

		{
			title: "CMS",
			description:
				"This project is my diploma final year project. It helps to automate the day to day activities of a University or College. The Project is developed in Java, PHP and MySQL",
			logo: "https://cdn.iconscout.com/icon/free/png-256/free-java-60-1174953.png",
			linkText: "View Project",
			link: "https://github.com/ShaneCoelho/College-Management-System",
		},
	],
};

export default INFO;
